import { apiUtils } from '../hooks';
import { throwApiError } from '../utils';
import { API_ENDPOINTS } from './apiEndpoints';
export interface SubscriptionFeature {
  id: string;
  feature_name: string;
  additional_info: string | null;
  is_active: boolean;
}

export interface Subscription {
  id: string;
  subscription_name: string;
  subscription_code: string;
  features: SubscriptionFeature[];
}

export interface SubscriptionListResponse {
  message: string;
  data: Subscription[];
}

export interface HotelSubscriptionResponse {
  message: string;
  data: Subscription;
}

interface PaymentLinkData {
  paymentUrl: string;
  sessionId: string;
  subscription: {
    id: string;
    name: string;
    code: string;
    price: number;
    offer_price: number;
    final_price: number;
    currency: string;
    description: string | null;
  };
  user: {
    id: string;
    email: string;
    name: string;
  };
}

export interface PaymentLinkResponse {
  message: string;
  data: PaymentLinkData;
}

class SubscriptionService {
  async getPlans(): Promise<Subscription[]> {
    try {
      // ApiResponse<T> expects T to be the inner data type
      const response = await apiUtils.get<Subscription[]>(
        API_ENDPOINTS.subscriptions.getPlans
      );
      // console.log('response.data::', response.data);
      return response.data.data;
    } catch (error) {
      throw throwApiError(error, 'Failed to fetch subscription plans');
    }
  }

  async getHotelSubscription(hotelId: string): Promise<Subscription> {
    try {
      // ApiResponse<T> expects T to be the inner data type
      const response = await apiUtils.get<Subscription>(
        `${API_ENDPOINTS.subscriptions.getHotelSubscriptions}`,
        { hotelId : hotelId }
      );
      // console.log('Hotel subscription response::', response.data);
      return response.data.data;
    } catch (error) {
      throw throwApiError(error, 'Failed to fetch hotel subscription');
    }
  }

  // Deprecated: Use getHotelSubscription instead
  // async getHotelSubscriptions(hotelId: string): Promise<Subscription[]> {
  //   try {
  //     const subscription = await this.getHotelSubscription(hotelId);
  //     return [subscription]; // Return as array for backward compatibility
  //   } catch (error) {
  //     throw throwApiError(error, 'Failed to fetch hotel subscriptions');
  //   }
  // }

  async getPaymentLink(hotelId: string, subscriptionId: string): Promise<string> {  
    try {
      // ApiResponse<T> has structure: { data: { data: T } }
      // So we want T to be PaymentLinkData
      const response = await apiUtils.get<PaymentLinkData>(
        API_ENDPOINTS.payment.getPaymentLink,
        { hotelId, subscriptionId }
      );
      // console.log('Payment link response::', response);
      // response.data.data is now PaymentLinkData
      return response.data.data.paymentUrl;
    } catch (error) {
      throw throwApiError(error, 'Failed to fetch payment link');
    }
  }
}

export const subscriptionService = new SubscriptionService();
